/* eslint-disable jira/filename-case */
import { createContext, type Context, type Dispatch, type SetStateAction } from 'react';
import noop from 'lodash/noop';

export const MoreMenuIsOpenContext: Context<MoreMenuIsOpenContext> =
	createContext<MoreMenuIsOpenContext>({
		moreMenuIsOpen: false,
		setMoreMenuIsOpen: noop,
	});

type MoreMenuIsOpenContext = {
	moreMenuIsOpen: boolean;
	setMoreMenuIsOpen: Dispatch<SetStateAction<boolean>>;
};
